import { JourneyDataModel } from '../../../../../services/redux/features/journeyData.slice';
import { DriverDetailsFormModel_OB_FP } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: DriverDetailsFormModel_OB_FP): Partial<JourneyDataModel> => {
  return {};
};
